var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoneyTipsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.14371C18.25 -2.00012 7.02788 2.25923 1.75 1.99994V11.4142H5.86271C6.26293 11.4142 6.65909 11.4943 7.02788 11.6497L10.9806 13.3157C11.8736 13.6921 12.9018 13.2654 13.266 12.3675C13.5743 11.6073 13.3071 10.7469 12.6506 10.2894C12.524 10.2012 12.3807 10.1461 12.2349 10.0955C11.3809 9.79887 8.31076 8.68959 8.51404 8.13899C8.75 7.49991 12.2201 6.06143 13.0603 4.99991C15.796 5.97572 18.0489 13.9445 21.75 16.5465L15.25 21.4999C10.5833 18.5726 10.6787 13.5128 8.36148 12.2118",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyTipsIcon);
export default __webpack_public_path__ + "static/media/moneyTipsIcon.b452d464.svg";
export { ForwardRef as ReactComponent };